import { get } from '..';

const GetLocationMetadata = (externalIds: string[]) => {
  let url: string = 'locations/metadata';
  url += `?externalIds=${externalIds[0]}`;
  for (let i = 1; i < externalIds.length; i += 1) url += `&externalIds=${externalIds[i]}`;
  return get(url);
};

export default GetLocationMetadata;
